import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";

export default function Blog() {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    api.get("/blog").then((r) => setPosts(r.data)).catch(() => {});
  }, []);

  const fmt = (iso) => new Date(iso).toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" });

  return (
    <div className="bg-[#0B132B]" data-testid="blog-page">
      <section className="py-16 lg:py-24 bg-[#0f1830] border-b border-[#1E293B]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="font-mono2 text-xs uppercase tracking-widest text-[#F97316] mb-3">Trucking Insights</p>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-black text-white tracking-tight leading-none" data-testid="blog-page-title">
            Deadlines, Permits & Straight Answers
          </h1>
          <p className="text-slate-400 mt-5 max-w-2xl text-sm sm:text-base leading-relaxed">
            Practical compliance guides written by the people who file this paperwork every day.
          </p>
        </div>
      </section>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        {posts.length === 0 ? (
          <p className="text-slate-500 text-sm" data-testid="blog-empty">No articles published yet — check back soon.</p>
        ) : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {posts.map((p) => (
              <Link key={p.id} to={`/blog/${p.slug}`} data-testid={`blog-card-${p.slug}`}
                className="group bg-[#131C38] border border-[#1E293B] rounded-lg overflow-hidden hover:border-[#F97316]/60 hover:translate-y-[-4px] transition-all duration-300">
                {p.cover_image && (
                  <div className="h-48 overflow-hidden">
                    <img src={p.cover_image} alt={p.title} loading="lazy"
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                  </div>
                )}
                <div className="p-6">
                  <p className="font-mono2 text-[11px] text-slate-500 uppercase tracking-wider mb-2">{fmt(p.created_at)}</p>
                  <h2 className="font-display text-xl font-semibold text-white leading-snug mb-2 group-hover:text-[#F97316] transition-colors">{p.title}</h2>
                  <p className="text-xs text-slate-400 leading-relaxed line-clamp-3">{p.excerpt}</p>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
